import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ICardFreeEntryItem } from '../../core/interfaces/ICardFreeEntryItem';
import { ICard } from '../../core/interfaces/ICard';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { AddEditFreeEntryFormComponent } from '../../forms/add-edit-free-entry-form/add-edit-free-entry-form.component';

@Component({
  selector: 'app-add-free-entry-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    AddEditFreeEntryFormComponent
  ],
  templateUrl: './add-free-entry-modal.component.html',
  styleUrl: './add-free-entry-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddFreeEntryModalComponent extends BaseModalComponent<ICardFreeEntryItem, AddEditFreeEntryFormComponent> {

  @Input({ required: true }) card: ICard;

  public isAdd = true;

  public constructor() {
    super();
    this.namespace = 'cards/add-free-entry-modal';
  }
}
